<template>
    <div>
        <v-dialog
            v-model="computedStremaTicketShow.show"
            :persistent="true"
            max-width="700px"
            :scrollable="true"
        >
            <v-card class="modal--tips4y">
                <v-card-title class="headline d-flex justify-center">
                    <h2 class="mb-0">{{ $t("strema-modal-title") }}</h2>
                    <div class="icon-close" @click="handleCloseTicket(1)">
                        <div>
                            <img
                                src="/images/_SVGs/environmental/fechar.svg"
                                onload="SVGInject(this)"
                                width="20"
                                height="20"
                            />
                        </div>
                    </div>
                </v-card-title>

                <v-card-text>
                    <v-form v-model="validateForm" ref="datarepair_form">
                        <v-row v-if="computedStremaTicketShow.mobilePhone">
                            <v-col cols="6"></v-col>
                            <v-col class="d-flex justify-content-end" cols="6">
                                <p>
                                    {{ $t("strema-tech-support-line") }}:
                                    {{ computedStremaTicketShow.mobilePhone }}
                                </p>
                            </v-col>
                        </v-row>
                        <v-row style="margin-top: -20px">
                            <v-col cols="9">
                                <v-text-field
                                    :label="$t('entity-name')"
                                    v-model="entityName"
                                    filled
                                    readonly
                                ></v-text-field>
                            </v-col>
                            <v-col cols="3">
                                <v-text-field
                                    :label="$t('nif')"
                                    v-model="nif"
                                    filled
                                    readonly
                                ></v-text-field>
                            </v-col>
                            <v-col cols="6" class="class-col">
                                <v-text-field
                                    :label="$t('strema-contact-name-label')"
                                    v-model="contactName"
                                    filled
                                    readonly
                                ></v-text-field>
                            </v-col>
                            <v-col cols="6" class="class-col">
                                <PhoneInput
                                    v-model="phone"
                                    @changed="
                                        (valid) => {
                                            phoneValid = valid;
                                        }
                                    "
                                />
                            </v-col>
                            <v-col cols="12" class="class-col">
                                <v-text-field
                                    type="email"
                                    label="Email"
                                    v-model="email"
                                    filled
                                    :rules="formRules.email"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row style="margin-top: -30px">
                            <v-subheader>{{
                                $t("strema-vehicle-label")
                            }}</v-subheader>
                        </v-row>

                        <v-row style="margin-top: -20px; position: relative">
                            <v-col
                                cols="4"
                                v-if="
                                    !vehicleSearchType ||
                                    (vehicleSearchType &&
                                        vehicleSearchType === 'searchByPlate')
                                "
                            >
                                <div v-if="vehicleComponentIsReady">
                                    <vehicle-search-component
                                        :mode="1"
                                        :showClear="showClear"
                                        :initPlate="plate"
                                        :strema="true"
                                        @on-plate-cleared="
                                            () => onPlateCleared(true)
                                        "
                                        @on-plate-search="onPlateSearch"
                                        @on-input-changed="onPlateChanged"
                                        :initCountry="country"
                                    />
                                </div>
                                <div
                                    v-if="
                                        (showPlateError && !tempPlate) ||
                                        (showPlateError && tempPlate == '')
                                    "
                                    style="padding: 0px 12px"
                                >
                                    <span
                                        style="color: #d90b3b; font-size: 12px"
                                    >
                                        {{
                                            this.$t(
                                                "backoffice.rules.min-chars",
                                                { field: "", min: 6 }
                                            )
                                        }}
                                    </span>
                                </div>
                            </v-col>
                            <v-col
                                cols="4"
                                v-else-if="
                                    vehicleSearchType &&
                                    vehicleSearchType === 'searchByManual'
                                "
                            >
                                <v-text-field
                                    :label="$t('vehicle-indentification.plate')"
                                    v-model="plate"
                                    filled
                                    :rules="formRules.plate"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="3">
                                <v-text-field
                                    v-if="
                                        !vehicleSearchType ||
                                        (vehicleSearchType &&
                                            vehicleSearchType ===
                                                'searchByPlate')
                                    "
                                    :readonly="showClear"
                                    :label="$t('strema-engine-code')"
                                    v-model="engineCode"
                                    filled
                                    :rules="showClear ? [] : formRules.engine"
                                ></v-text-field>
                                <v-text-field
                                    v-else-if="
                                        vehicleSearchType &&
                                        vehicleSearchType === 'searchByManual'
                                    "
                                    :label="$t('strema-engine-code')"
                                    v-model="engineCode"
                                    filled
                                    :rules="formRules.engine"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="5">
                                <v-text-field
                                    v-if="
                                        !vehicleSearchType ||
                                        (vehicleSearchType &&
                                            vehicleSearchType ===
                                                'searchByPlate')
                                    "
                                    :readonly="showClear"
                                    :label="$t('details-component.vin')"
                                    v-model="vin"
                                    filled
                                    :rules="formRules.vin2"
                                ></v-text-field>
                                <v-text-field
                                    v-else-if="
                                        vehicleSearchType &&
                                        vehicleSearchType === 'searchByManual'
                                    "
                                    :label="$t('details-component.vin')"
                                    v-model="vin"
                                    filled
                                    :rules="formRules.vin2"
                                ></v-text-field>
                            </v-col>
                            <span
                                v-if="showPlateNotFound"
                                style="
                                    position: absolute;
                                    bottom: 20px;
                                    left: 13px;
                                    color: red;
                                "
                                >{{
                                    $t(
                                        "backoffice.templates.messages.vehicle-not-found-plate"
                                    )
                                }}</span
                            >
                        </v-row>
                        <v-row style="margin-top: -20px">
                            <v-col cols="5">
                                <v-text-field
                                    :readonly="showClear"
                                    :label="$t('details-component.make')"
                                    v-model="make"
                                    filled
                                    :rules="formRules.brand"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="7">
                                <v-text-field
                                    :readonly="showClear"
                                    :label="$t('details-component.model')"
                                    v-model="model"
                                    filled
                                    :rules="formRules.model"
                                ></v-text-field>
                            </v-col>
                            <!-- CAMPO VehicleID apagado do formulário - reunião 23/07/2024 -->
                        </v-row>
                        <v-row style="margin-top: -30px">
                            <v-subheader>{{
                                $t("strema-message-label")
                            }}</v-subheader>
                        </v-row>
                        <v-row style="margin-top: -20px">
                            <v-container fluid>
                                <v-textarea
                                    name="input-7-1"
                                    filled
                                    auto-grow
                                    v-model="message"
                                    counter="500"
                                    :rules="formRules.obsRules"
                                ></v-textarea>
                            </v-container>
                        </v-row>
                        <v-row style="margin-top: -30px">
                            <v-btn
                                text
                                class="pl-0 pr-0"
                                :disabled="attachments.length == 4"
                                @click="
                                    modalUpload.show = true;
                                    clearFile = false;
                                "
                            >
                                <v-subheader
                                    >{{ $t("strema-attachments-label") }}
                                    <img
                                        src="/images/_SVGs/paperclip.svg"
                                        class="ml-1 mr-1"
                                        onload="SVGInject(this)"
                                        width="20"
                                /></v-subheader>
                            </v-btn>
                            <div
                                style="margin-top: 6px"
                                cols="10"
                                class="d-flex flex-row"
                            >
                                <div
                                    v-for="(file, index) in attachments"
                                    :key="index"
                                >
                                    <span>
                                        {{
                                            index == 1
                                                ? `, ${file.name.substring(
                                                      0,
                                                      5
                                                  )}...`
                                                : index == 0
                                                ? file.name
                                                : ""
                                        }}
                                    </span>
                                    <span @click="removeFile(file, index)">
                                        <img
                                            src="/images/_SVGs/trash-can-orange-whitebg.svg"
                                            class="ml-1 mr-1"
                                            onload="SVGInject(this)"
                                            width="20"
                                        />
                                    </span>
                                </div>
                            </div>
                        </v-row>
                    </v-form>
                </v-card-text>

                <v-card-actions class="row-button justify-center">
                    <div class="ml-2">
                        <v-btn
                            class="primary-button"
                            text
                            :disabled="validadeBtnSendTicked()"
                            @click="handleSendTicket"
                        >
                            <span style="text-transform: capitalize">{{
                                $t("strema-send-label")
                            }}</span>
                        </v-btn>
                    </div>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <base-modal
            v-model="modalUpload.show"
            :title="modalUpload.title"
            modal-width="560px"
            :persistent="true"
        >
            <template v-slot:modal-close>
                <div @click="modalUpload.show = false">
                    <img
                        src="/images/_SVGs/environmental/fechar.svg"
                        onload="SVGInject(this)"
                        width="20"
                        height="20"
                    />
                </div>
            </template>

            <template v-slot:modal-body>
                <InputFile
                    :clear="clearFile"
                    accept=".pdf,.png,.jpg,.jpeg"
                    @loadUpload="loadUploadEmit"
                />
                <p class="text-center">
                    <small>{{ $t("input-upload-att-subtitle") }}</small>
                </p>
            </template>

            <template v-slot:modal-actions>
                <div class="mr-2">
                    <v-btn class="danger-button" text @click="closeModal">
                        {{ $t("cancel") }}
                    </v-btn>
                </div>
                <div class="ml-2">
                    <v-btn
                        class="primary-button"
                        text
                        :disabled="!fileUpload"
                        @click="afterSaveUpload"
                    >
                        {{
                            $t("environmental-management.documentation.charge")
                        }}
                    </v-btn>
                </div>
            </template>
        </base-modal>

        <base-modal
            v-model="modalCancel.show"
            :title="modalCancel.title"
            modal-width="560px"
            :persistent="true"
        >
            <template v-slot:modal-body>
                <span>{{ modalCancel.message }}</span>
            </template>

            <template v-slot:modal-actions>
                <div class="mr-2">
                    <v-btn
                        class="danger-button"
                        text
                        @click="handleCloseTicketModal(3)"
                    >
                        {{ $t("cancel") }}
                    </v-btn>
                </div>
                <div class="ml-2">
                    <v-btn
                        class="primary-button"
                        text
                        @click="handleCloseTicketModal(2)"
                    >
                        {{ $t("exit") }}
                    </v-btn>
                </div>
            </template>
        </base-modal>

        <base-modal
            v-model="modalInfo.show"
            :title="modalInfo.title"
            modal-width="560px"
            :persistent="true"
        >
            <template v-slot:modal-body>
                <span>{{ modalInfo.message }}</span>
                <br />
                <span>
                    <strong>{{ modalInfo.ticketnr }}</strong>
                </span>
            </template>

            <template v-slot:modal-actions>
                <div class="ml-2">
                    <v-btn
                        class="primary-button"
                        text
                        @click="modalInfoClose()"
                    >
                        {{ $t("ok") }}
                    </v-btn>
                </div>
            </template>
        </base-modal>
    </div>
</template>

<script>
import { UserServicesSendStremaTicket } from "@services/UserServices";
import { isEmail } from "@src/utils/validations.js";
import BaseModal from "@components/shared/widgets/BaseModal.vue";

export default {
    components: {
        BaseModal,
        VehicleSearchComponent: () =>
            import(
                "@components/shared/widgets/vehicle-identification/VehicleSearchComponent"
            ),
        PhoneInput: () => import("@components/shared/widgets/PhoneInput"),
        InputFile: () => import("@components/b2b/widgets/InputFile"),
    },

    data() {
        return {
            showPlateNotFound: false,
            showClear: false,
            validateForm: false,
            ticketNr: "01/2023",
            entityName: "",
            nif: "",
            contactName: "",
            phone: "",
            phoneValid: true,
            email: "",
            make: "",
            model: "",
            vehicleId: "",
            vin: "",
            engineCode: "",
            plate: "",
            country: "",
            message: "",
            attachments: [],
            modalUpload: {
                show: false,
                id_upload: null,
                title: "",
            },
            fileUpload: null,
            clearFile: false,
            modalCancel: {
                show: false,
                title: "",
                message: "",
            },
            modalInfo: {
                show: false,
                title: "",
                message: "",
                ticketnr: "",
            },
            formRules: {
                email: [(v) => isEmail(v) || this.$t("email-validate-input")],
                brand: [
                    (v) =>
                        !v ||
                        (v && v.length === 0) ||
                        (v && v.length <= 20) ||
                        this.$t("planning.form-planning-event.max-chars", {
                            chars: 20,
                        }),
                ],
                model: [
                    (v) =>
                        !v ||
                        (v && v.length === 0) ||
                        (v && v.length <= 60) ||
                        this.$t("planning.form-planning-event.max-chars", {
                            chars: 60,
                        }),
                ],
                vehicleId: [
                    (v) =>
                        !v ||
                        (v && v.length === 0) ||
                        (v && v.length <= 10) ||
                        this.$t("planning.form-planning-event.max-chars", {
                            chars: 10,
                        }),
                ],
                vin: [
                    (v) =>
                        !v ||
                        (v && v.length === 0) ||
                        (v && v.length == 17) ||
                        this.$t("planning.form-planning-event.number-chars", {
                            chars: 17,
                        }),
                ],
                engine: [
                    (v) =>
                        !v ||
                        (v && v.length === 0) ||
                        (v && v.length <= 15) ||
                        this.$t("planning.form-planning-event.max-chars", {
                            chars: 15,
                        }),
                ],
                obsRules: [
                    (v) => (v && v.length <= 500) || this.$t("required-input"),
                ],
                vin2: [
                    (v) =>
                        (v && v.length == 17) ||
                        this.$t("planning.form-planning-event.number-chars", {
                            chars: 17,
                        }),
                ],
                engine2: [
                    (v) =>
                        (v && v.length <= 15) ||
                        this.$t("planning.form-planning-event.max-chars", {
                            chars: 15,
                        }),
                ],
                plate: [
                    (v) =>
                        (v && v.length > 5) ||
                        this.$t("backoffice.rules.min-chars", {
                            min: 6,
                        }),
                ],
            },
            searchedOnForm: false,
            vehicleSearchDetailsTemporary: [],
            clearedTheSearchAndWroteManually: false,
            vehicleComponentIsReady: false,
            vehicleSearchType: null,
            showPlateError: true,
            tempPlate: "",
        };
    },

    computed: {
        computedStremaTicketShow() {
            return this.$store.getters["menuLinks/getDatarepairState"];
        },
        computedVehicleStoreType() {
            const getViState =
                this.$store.getters["vehicleIdentification/getState"];
            return getViState.typeSearch;
        },
    },

    watch: {
        computedStremaTicketShow: {
            handler: function (newValue, oldValue) {
                const isOpening =
                    newValue.show === true &&
                    (!oldValue || oldValue.show === false);
                if (isOpening) {
                    try {
                        if (this.$analytics) {
                            this.$analytics.supportPopupOpened();
                        }
                    } catch (_) {}
                }

                if (newValue.show === false) {
                    this.plate = "";
                    this.tempPlate = "";
                    this.showClear = false;
                    this.onPlateCleared(true);
                    this.vehicleSearchType = null;
                }
                if (!this.computedStremaTicketShow.show) return;
                const userState = this.$store.getters["auth/getState"];
                this.contactName = userState.fullName;
                this.nif = userState.nif;
                this.entityName = userState.company;
                this.email = userState.email;
                this.phone = userState?.phone ? userState.phone : "";
                const vehicleState =
                    this.$store.getters["vehicleIdentification/getState"];
                if (
                    vehicleState.data &&
                    vehicleState.data.length &&
                    Array.isArray(vehicleState.data) &&
                    vehicleState.token !== undefined
                ) {
                    this.vehicleSearchType = vehicleState.typeSearch;
                    this.clearedTheSearchAndWroteManually = false;
                    this.plate = vehicleState.plateNumber;
                    this.tempPlate = vehicleState.plateNumber;
                    this.country = vehicleState.dataSourceId;

                    this.make = this.$helpers.getVehicleAttributeValue(
                        this.$globals.ATTRIB_ID.MAKE
                    );
                    this.model = this.$helpers.getVehicleAttributeValue(
                        this.$globals.ATTRIB_ID.MODEL
                    );
                    this.vin = this.$helpers.getVehicleAttributeValue(
                        this.$globals.ATTRIB_ID.VIN
                    );
                    this.engineCode = this.$helpers.getVehicleAttributeValue(
                        this.$globals.ATTRIB_ID.ENGINE_CODE
                    );
                    this.vehicleId = this.$helpers.getVehicleAttributeValue(
                        this.$globals.ATTRIB_ID.VEHICLE_ID
                    );

                    this.showClear = true;
                    (this.searchedOnForm = false),
                        (this.vehicleSearchDetailsTemporary = []);
                } else {
                    this.plate = "";
                    this.tempPlate = "";
                    this.showClear = false;
                }
                this.vehicleComponentIsReady = true;

                this.handleWithValidateForm();
                return newValue;
            },
            deep: true,
            immediate: true,
        },

        computedVehicleStoreType: {
            handler: function (newValue, oldValue) {
                return newValue;
            },
            deep: true,
            immediate: true,
        },
    },

    methods: {
        onPlateCleared(clearPlate = true) {
            this.showPlateError = true;
            this.tempPlate = "";
            this.clearVehicleData(clearPlate);
            this.showClear = false;
            this.clearedTheSearchAndWroteManually = true;
        },
        onInputChanged(input) {
            this.showPlateNotFound = false;
            if (input == false) {
                this.showPlateNotFound = true;
            } else if (this.plate != input) {
                this.onPlateCleared(false);
            }
        },
        async onPlateSearch(vehicleState) {
            this.showPlateError = false;
            this.clearedTheSearchAndWroteManually = false;
            if (vehicleState.data && vehicleState.data.length) {
                this.plate = vehicleState.plateNumber;
                vehicleState.data.forEach((info) => {
                    if (info.attribID == this.$globals.ATTRIB_ID.MAKE) {
                        this.make = info.value;
                    } else if (info.attribID == this.$globals.ATTRIB_ID.MODEL) {
                        this.model = info.value;
                    } else if (info.attribID == this.$globals.ATTRIB_ID.VIN) {
                        this.vin = info.value;
                    } else if (
                        info.attribID == this.$globals.ATTRIB_ID.ENGINE_CODE
                    ) {
                        this.engineCode = info.value;
                    } else if (
                        info.attribID == this.$globals.ATTRIB_ID.VEHICLE_ID
                    ) {
                        this.vehicleId = info.value;
                    }
                });
                this.showClear = true;
                this.searchedOnForm = true;
                this.vehicleSearchDetailsTemporary =
                    await this.handleWithVehicleSearchData(vehicleState);
            }
        },
        async handleWithVehicleSearchData(vehicle, force) {
            // Função de comparação para ordenar com base na posição em desiredAttribIDs
            const desiredAttribIDs = [
                this.$globals.ATTRIB_ID.PLATE_DATE,
                this.$globals.ATTRIB_ID.VIN,
                this.$globals.ATTRIB_ID.MODEL,
                this.$globals.ATTRIB_ID.MAKE,
                this.$globals.ATTRIB_ID.VERSION,
                this.$globals.ATTRIB_ID.BUILD_YEAR,
                this.$globals.ATTRIB_ID.CUBIC_CAP,
                this.$globals.ATTRIB_ID.POWER_KW,
                this.$globals.ATTRIB_ID.POWER_CV,
                this.$globals.ATTRIB_ID.FUEL_TYPE,
                this.$globals.ATTRIB_ID.GEARBOX,
                this.$globals.ATTRIB_ID.DRIVE,
                this.$globals.ATTRIB_ID.ENGINE_CODE,
            ];
            function compareByDesiredAttribIDs(a, b) {
                const indexA = desiredAttribIDs.indexOf(a.attribID);
                const indexB = desiredAttribIDs.indexOf(b.attribID);
                return indexA - indexB;
            }

            let vehicleSearchDetailsData = [];
            if (force) {
                for (let i in vehicle.detailsData) {
                    const attribID = vehicle.detailsData[i].attribID;
                    if (desiredAttribIDs.includes(attribID)) {
                        vehicleSearchDetailsData.push(vehicle.detailsData[i]);
                    }
                }
            } else {
                for (let i in vehicle.data) {
                    const attribID = vehicle.data[i].attribID;
                    if (desiredAttribIDs.includes(attribID)) {
                        let newObj = {
                            attribID: vehicle.data[i].attribID,
                            name: await this.handleWithVehicleDescriptionDataName(
                                vehicle.data[i].description
                            ),
                            value: vehicle.data[i].value,
                        };
                        vehicleSearchDetailsData.push(newObj);
                    }
                }
            }

            vehicleSearchDetailsData.sort(compareByDesiredAttribIDs);
            if (this.plate) {
                vehicleSearchDetailsData.push({
                    name: this.$t("vehicle-indentification.plate"),
                    value: this.plate ? this.plate.toUpperCase() : "",
                });
            }

            return vehicleSearchDetailsData;
        },
        async handleWithVehicleDescriptionDataName(description) {
            let name = description;
            if (description == "Plate_Date") {
                name = this.$t("details-component.plate-date");
            } else if (description == "VIN") {
                name = this.$t("details-component.vin");
            } else if (description == "Make") {
                name = this.$t("details-component.make");
            } else if (description == "Model") {
                name = this.$t("details-component.model");
            } else if (description == "Version") {
                name = this.$t("details-component.version");
            } else if (description == "Build_Year") {
                name = this.$t("details-component.build-year");
            } else if (description == "Cubic_Cap") {
                name = this.$t("details-component.cubic-cap");
            } else if (description == "Power_kW") {
                name = this.$t("details-component.power-kw");
            } else if (description == "Power_CV") {
                name = this.$t("details-component.power-cv");
            } else if (description == "Fuel_Type") {
                name = this.$t("details-component.fuel-type");
            } else if (description == "Gearbox") {
                name = this.$t("details-component.gearbox");
            } else if (description == "Drive") {
                name = this.$t("details-component.drive");
            } else if (description == "Engine_Code") {
                name = this.$t("details-component.engine-code");
            }

            return name;
        },
        handleCloseTicket(id) {
            if (id === 1) {
                this.modalCancel.title = this.$t("strema-modal-cancel-title");
                this.modalCancel.message = this.$t(
                    "strema-modal-cancel-message"
                );
                this.modalCancel.show = true;
            }
        },
        loadUploadEmit(file) {
            if (file) {
                this.fileUpload = file;
            }
        },
        closeModal() {
            this.fileUpload = null;
            this.modalUpload.show = false;
            this.clearFile = true;
        },
        async afterSaveUpload() {
            let newAttach = {
                name: this.fileUpload.name,
                file: this.fileUpload,
            };
            this.attachments.push(newAttach);

            await this.$nextTick();

            this.closeModal();
        },
        clearData() {
            this.phone = "";
            this.email = "";
            this.message = "";
            this.attachments = [];
            this.clearVehicleData();
        },
        async clearVehicleData(clearPlate = true) {
            this.make = "";
            this.vin = "";
            this.engineCode = "";
            this.model = "";
            this.country = "";
            this.vehicleId = "";
            if (clearPlate) {
                this.plate = "";
            }

            setTimeout(() => {
                this.vehicleComponentIsReady = true;
            }, 2000);
        },
        async removeFile(file, index) {
            this.attachments.splice(index, 1);
        },
        async handleCloseTicketModal(id) {
            if (id === 2) {
                this.vehicleComponentIsReady = false;
                this.plate = "";
                this.showClear = false;
                await this.clearVehicleData(true);
                this.attachments = [];
                this.modalCancel.show = false;
                this.$store.commit("menuLinks/setDatarepairStateShow", false);
                this.clearData();
            } else if (id === 3) {
                this.modalCancel.show = false;
            }
        },
        async handleSendTicket() {
            this.$store.commit("loadings/setStateLoadingTemplate", true);
            const body = await this.mountPayload();

            UserServicesSendStremaTicket(body)
                .then((response) => {
                    this.modalInfo.ticketnr = `${this.$t(
                        "strema-ticket-label"
                    )}: ${response.data.result}`;
                    this.modalInfo.title = this.$t(
                        "backoffice.general.success"
                    );
                    this.modalInfo.message = this.$t("strema-success-message");

                  try {
                    if (this.$analytics) {
                      const messageLength = this.message ? this.message.length : 0;
                      this.$analytics.supportTicketSubmitted({
                        message_length: messageLength
                      });
                    }
                  } catch (_) {}
                })
                .catch((error) => {
                    this.$requestStatus.checkRequestStatus(
                        error.response.status,
                        this.$route.name
                    );
                    this.modalInfo.title = this.$t("strema-modal-cancel-title");
                    this.modalInfo.message = this.$t("strema-error-message");

                    throw new Error("error sending strema ticket", error);
                })
                .finally(() => {
                    this.$store.commit(
                        "loadings/setStateLoadingTemplate",
                        false
                    );
                    this.computedStremaTicketShow.show = false;
                    this.clearData();
                    this.modalInfo.show = true;
                });
        },
        async modalInfoClose() {
            this.vehicleComponentIsReady = false;
            this.modalInfo.show = false;
            this.$store.commit("menuLinks/setDatarepairStateShow", false);
            await this.clearData();
        },
        async mountPayload() {
            let sortVehicleDetailsData = [];
            if (this.searchedOnForm) {
                sortVehicleDetailsData = this.vehicleSearchDetailsTemporary;
            } else {
                const vehicle =
                    this.$store.getters["vehicleIdentification/getState"];
                sortVehicleDetailsData = await this.handleWithVehicleSearchData(
                    vehicle,
                    true
                );
            }

            const index3 = sortVehicleDetailsData.findIndex(
                (item) => item.attribID === this.$globals.ATTRIB_ID.PLATE_DATE
            );
            const index14 = sortVehicleDetailsData.findIndex(
                (item) => item.attribID === this.$globals.ATTRIB_ID.BUILD_YEAR
            );

            if (index3 !== -1 && index14 !== -1) {
                const [item14] = sortVehicleDetailsData.splice(index14, 1);
                sortVehicleDetailsData.splice(index3 + 1, 0, item14);
            }

            let body = {
                make: this.make,
                model: this.model,
                vin: this.vin,
                engineCode: this.engineCode,
                plate:
                    this.plate && this.plate !== ""
                        ? this.plate
                        : this.tempPlate,
                message: this.message,
                email: this.email,
                phone: this.phone,
                vehicleId: this.vehicleId,
                contactName: this.contactName,
            };

            body["vehicleSearchDetails"] = sortVehicleDetailsData;

            if (
                this.plate &&
                this.plate !== "" &&
                this.vehicleSearchType &&
                this.vehicleSearchType === "searchByPlate"
            ) {
                delete body.vehicleId;
            } else if (
                this.plate &&
                this.plate !== "" &&
                !this.vehicleSearchType
            ) {
                delete body.vehicleId;
            } else if (
                this.tempPlate !== "" &&
                this.vehicleSearchType &&
                this.vehicleSearchType === "searchByPlate"
            ) {
                delete body.vehicleId;
            } else if (
                this.tempPlate &&
                this.tempPlate !== "" &&
                !this.vehicleSearchType
            ) {
                delete body.vehicleId;
            }

            if (this.clearedTheSearchAndWroteManually) {
                delete body.vehicleSearchDetails;
            }

            if (
                this.plate &&
                this.plate !== "" &&
                this.vehicleSearchType &&
                this.vehicleSearchType === "searchByManual"
            ) {
                if (this.engineCode && this.engineCode !== "") {
                    const engine = {
                        attribID: 41,
                        name: this.$t("details-component.engine-code"),
                        value: this.engineCode,
                    };
                    body.vehicleSearchDetails.push(engine);
                }
                const vin = {
                    attribID: 17,
                    name: this.$t("details-component.vin"),
                    value: this.vin,
                };
                body.vehicleSearchDetails.push(vin);
            }

            body = JSON.stringify(body);

            let formData = new FormData();
            formData.append("request", body);

            this.attachments.forEach((f) => {
                formData.append("files", f.file);
            });

            await this.$nextTick();
            return formData;
        },
        validadeBtnSendTicked() {
            function checkContentVariables(a, b) {
                return (
                    (a !== "" && a !== null && a !== undefined) ||
                    (b !== "" && b !== null && b !== undefined)
                );
            }
            const checkIfHasPhoneOrEmail = checkContentVariables(
                this.phone,
                this.email
            );
            return (
                !checkIfHasPhoneOrEmail ||
                !this.validateForm ||
                (this.attachments.length == 0 && !this.message) ||
                (this.phone !== "" && !this.phoneValid) ||
                (this.tempPlate &&
                    this.tempPlate == "" &&
                    this.vehicleSearchType === "searchByPlate") ||
                (this.tempPlate &&
                    this.tempPlate == "" &&
                    !this.vehicleSearchType) ||
                (!this.tempPlate && !this.vehicleSearchType) ||
                (!this.tempPlate && this.vehicleSearchType === "searchByPlate")
            );
        },
        onPlateChanged(plateVal) {
            this.tempPlate = plateVal;
        },
        async handleWithValidateForm() {
            setTimeout(() => {
                if (this.$refs.datarepair_form) {
                    this.$refs.datarepair_form.validate();
                }
            }, 2000);
        },
    },

    mounted() {}
};
</script>

<style lang="scss">
@import "@sass/_variables.scss";
.v-subheader {
    align-items: center;
    display: flex;
    height: 48px;
    font-size: 0.9rem;
    font-weight: bold;
    padding: 0 16px;
}

.class-col {
    margin-top: -30px;
}
</style>
